<mat-dialog-content class="text-center max-h-[400px] max-w-[650px] overflow-y-hidden">
    <div>
        <div>
            <div class="grid grid-cols-6 gap-3 py-2 px-10 font-semibold bg-gray-50 sticky top-0 z-10">
                <div>Job Number</div>
                <div>Job Date</div>
                <div>Bank Name</div>
                <div>Branch Name</div>
                <div>Status Name</div>
                <div>Notes</div>
            </div>

            <div *ngFor="let inward of inwards; trackBy: trackByFn"
                class="grid grid-cols-6 gap-3 py-2 px-10 border-b hover:bg-gray-50">
                <div (click)="openReport(inward)"
                    class="inline-flex items-center font-bold text-xs px-2.5 py-1.5 rounded-full tracking-wide uppercase w-13 h-7"
                    [ngClass]="{
                                                'text-green-800 bg-green-200 dark:text-green-50 dark:bg-green-500': inward.dueDate && !isOverdue(inward.dueDate),
                                                'text-red-800 bg-red-200 dark:text-red-50 dark:bg-red-500': inward.dueDate && isOverdue(inward.dueDate),
                                                'celebration': inward.isFinalizeReport
                                            }">{{ inward.jobNumber }}</div>
                <div class="md:block">{{ inward.inwardDate | date:'dd/MM/yyyy' }}</div>
                <div class="md:block">{{ inward.bankName }}</div>
                <div class="md:block">{{ inward.bankBranchName }}</div>
                <div class="md:block">{{ inward.inwardStatus }}</div>
                <div class="md:block">{{ inward.note }}</div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onOk()">Close</button>
</mat-dialog-actions>